import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { DxNumberBoxComponent } from 'devextreme-angular';

@Component({
  selector: 'app-art-input-check-number',
  templateUrl: './art-input-check-number.component.html',
  styleUrls: ['./art-input-check-number.component.css']
})
export class ArtInputCheckNumberComponent implements OnInit, AfterViewInit{
  @ViewChild('KeyIdX', { static: false }) KeyIdX: DxNumberBoxComponent;

  item;
  @Input()  value:string;
  @Input()  disabled:boolean;
  @Output() findFirstFree = new EventEmitter<any>();
  @Output() findById = new EventEmitter<any>();
  @Input()  format:string="00000";
  @Input()  length:number=-1;
  constructor() { }
  ngAfterViewInit(){
    console.log(this.KeyIdX);
    //alert(this.disabled);
    this.KeyIdX.instance.option('format','#'+this.format);
  }
  ngOnInit() {
      this.item['value']=this.value;
      
  }
  keyDown(ev){
    console.log(ev);
    let ciccio=""+ev.component._parsedValue;
    //alert(ciccio);
    if(ciccio.length>this.length-1 && ev.event.keyCode !=8 && ev.event.keyCode !=37 && ev.event.keyCode !=39)    event.preventDefault();
    //alert(ev.component._formattedValue);
    return false;
  }
  keyUp(ev:any){
    //console.log(ev);
    //alert(ev.component._formattedValue);
    if(ev.event.keyCode==13)        
    this.findById.emit(ev.component._formattedValue);        
 }
 checkValid(value){    
  let xT =""+parseInt(value); 
  if(xT=="NaN") xT=this.format;
  xT=this.format+xT
  let xTl=this.format.length;
  xT=xT.substr(-xTl,xTl); 
  let result=xT;
  return result;
}
 primolibero(){    
  let xT=this.checkValid(this.value);    
  this.findFirstFree.emit(xT);
}


}
